import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OnboardingPage } from './onboarding.page';
import { AddressCreatePage } from '../address/create.page';
import { AddressListPage } from '../address/list.page';
import { SuggestionPage } from '../suggestion/suggestion.page';
import { NotificationsPage } from './notifications/notifications.page';

export const ONBOARDING_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'welcome',
  },
  {
    path: 'welcome',
    component: OnboardingPage,
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./notifications/notifications.page').then(
        (m) => m.NotificationsPage
      ),
  },
  {
    path: 'address/create',
    component: AddressCreatePage,
  },
  {
    path: 'address/list',
    component: AddressListPage,
  },
  {
    path: 'suggestion/list',
    component: SuggestionPage,
  },
  {
    path: 'suggestion/search',
    loadComponent: () =>
      import('../suggestion/suggestion-search.page').then(
        (m) => m.SuggestionSearchPage
      ),
  },
];
